import { useEffect, useState, useRef } from 'react';
import URL from '../../classes/Url/URL';
import Api from '../../classes/Api/Api';
import { useParams } from 'react-router-dom';

const DmrvChart = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const chartContainer = useRef(null);

  const [options, setOptions] = useState({
    chart: {
      id: 'basic-bar',
    },
    xaxis: {
      categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999],
    },
  });

  const [series, setSeries] = useState([
    {
      name: 'series-1',
      data: [30, 40, 45, 50, 49, 60, 70, 91],
    },
  ]);

  useEffect(async () => {
    const url = `${URL.URL_SERVER}/projects/${id}/dmrv`;
    const api = new Api(url);
    const response = await api.get();
    const { data } = response;
    const { resources } = data;

    const categories = resources.map((element) => element.date);
    const new_data = resources.map((element) => element.tons);
    setOptions({
      chart: {
        id: 'basic-bar',
      },
      xaxis: {
        categories,
      },
    });
    setSeries([
      {
        name: 'series-1',
        data: new_data,
      },
    ]);
    setLoading(true);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const containerWidth = chartContainer.current.clientWidth;
      setOptions((prevOptions) => ({
        ...prevOptions,
        chart: {
          ...prevOptions.chart,
          width: containerWidth,
        },
      }));
    };
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="app">
      <div className="row">
        <div className="mixed-chart" ref={chartContainer}>
          {loading && (
            <span
              style={{
                fontSize: '30px',
                color: '#000',
                display: 'table',
                marginTop: '25%',
                marginLeft: '20%',
              }}
            >
              Real time data will be live soon
            </span>
          )}
          {/* !loading && <Chart options={options} series={series} type="line" /> */}
        </div>
      </div>
    </div>
  );
};

export default DmrvChart;
